export const INIT = 1;
export const CONNECTING = 2;
export const CONNECTED = 3;
export const BUSY = 4;